import { Case, Opinion, QueueConfiguration, ReleaseCaseData, AuthProvider, CustodyChain, Feedback } from 'services';

export function generateModeratorFeedback(caseData: Case, opinion: Opinion, config: QueueConfiguration): Feedback {
  const userName = AuthProvider.getAccount().userName;
  const custodyChain: CustodyChain = {
    custodyStartTime: new Date(),
    custodian: 'GMX',
    custodianVersion: '1'
  };

  return {
    caseDocId: caseData.id,
    feedbackDateTime: new Date(),
    source: {
      sourceId: userName,
      sourceType: 'Moderator',
      sourceTenantId: config.tenant.tenantId,
      sourceTitleId: config.title.titleId
    },
    subject: caseData.subject,
    opinion: opinion,
    custodyChain: [custodyChain]
  };
}

// Creates the Payload to send to GMC for Release Case
// Feedback and Actions are recorded in this request body as well
export function generateReleaseData(caseData: Case, opinion: Opinion, config: QueueConfiguration): ReleaseCaseData {
  return {
    caseId: caseData.id,
    case: caseData,
    feedback: generateModeratorFeedback(caseData, opinion, config)
  };
}

export function isEmptyObject(obj: Record<string, unknown>): boolean {
  if (obj == null) {
    return true;
  }

  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
